import _defineProperty from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import getSymbolFromCurrency from 'currency-symbol-map';
export function formatCurrency(_ref) {
  var amount = _ref.amount,
      _ref$currency = _ref.currency,
      currency = _ref$currency === void 0 ? 'GBP' : _ref$currency,
      _ref$userLocale = _ref.userLocale,
      userLocale = _ref$userLocale === void 0 ? 'en-GB' : _ref$userLocale,
      _ref$minimumFractionD = _ref.minimumFractionDigits,
      minimumFractionDigits = _ref$minimumFractionD === void 0 ? 0 : _ref$minimumFractionD,
      options = _ref.options;

  try {
    var formatter = new Intl.NumberFormat(userLocale, _objectSpread({
      style: 'currency',
      currency: currency,
      minimumFractionDigits: minimumFractionDigits,
      currencyDisplay: 'narrowSymbol'
    }, options));
    return formatter.format(amount);
  } catch (err) {
    console.error(err);
    return '';
  }
}
export function formatDate(_ref2) {
  var date = _ref2.date,
      _ref2$userLocale = _ref2.userLocale,
      userLocale = _ref2$userLocale === void 0 ? 'en-GB' : _ref2$userLocale,
      options = _ref2.options;
  if (!date) return '';
  var formatter = new Intl.DateTimeFormat(userLocale, _objectSpread({
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  }, options));
  var datetStr = '';

  try {
    datetStr = formatter.format(new Date(date));
  } catch (_) {}

  return datetStr;
}
export function formatCurrencyToNumber(value) {
  if (!value) return null;

  if (typeof value === 'string') {
    var tmp = value.split('');
    tmp = tmp.filter(function (i) {
      return !isNaN(+i) && i;
    });
    tmp = tmp.join('');
    return +tmp;
  }

  return value;
}
export function formatSnakeCase(str) {
  return str === null || str === void 0 ? void 0 : str.replace(/[-_]/g, ' ');
}
export function toCapitalCase(str) {
  return (str === null || str === void 0 ? void 0 : str.charAt(0).toUpperCase()) + (str === null || str === void 0 ? void 0 : str.slice(1));
} // truncate text to a certain length

export function truncateText(text, length) {
  return (text === null || text === void 0 ? void 0 : text.length) > length ? "".concat(text === null || text === void 0 ? void 0 : text.slice(0, length), "...") : text;
}
export function toMidnightISOString(date) {
  var newDate = new Date(date);
  newDate.setUTCHours(0, 0, 0, 0);
  return newDate.toISOString();
}
export function roundOffToEndOfMonth(date) {
  var newDate = new Date(date.getTime());
  newDate.setMonth(newDate.getMonth() + 1);
  newDate.setDate(0);
  return newDate;
}
export var getCurrencySymbol = function getCurrencySymbol() {
  var currency = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'EUR';
  return getSymbolFromCurrency(currency);
};
export var convertCamelCaseToUnderscore = function convertCamelCaseToUnderscore(str) {
  if (!str) return str;
  return str === null || str === void 0 ? void 0 : str.replace(/([A-Z])/g, function (match) {
    return "_".concat(match.toLowerCase());
  });
};